import { BaseTag } from 'mixs/base/base_mixin';
import { Scopes }  from 'apps/scopes';

class TwoWeeks extends BaseTag {
  phases: any;
  init(){
    super.init();
    this.opts.phases = {}
    let phase_ids = Scopes.getData().phase_ids;
    for(let i=0;i<phase_ids.length; i++){
      let phase_id = phase_ids[i]
      let phaseData = Scopes.getPhaseData(phase_id);
      this.opts.phases[phaseData.identity] = phaseData;
    }
  }
  has_castings(){
    return true
    // return Scopes.getMaterialData(material_id).name
  }
}

riot.mixin('calendars.two_weeks', TwoWeeks as riot.TagMixin)
